/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `College Senior` - College Senior
* `College Junior` - College Junior
* `College Sophomore` - College Sophomore
* `College Freshman` - College Freshman
* `High School Senior` - High School Senior
* `High School Junior` - High School Junior
* `High School Sophomore` - High School Sophomore
* `High School Freshman` - High School Freshman
* `8th Grade` - 8th Grade
* `7th Grade` - 7th Grade
* `6th Grade` - 6th Grade
* `5th Grade` - 5th Grade
* `4th Grade` - 4th Grade
* `3rd Grade` - 3rd Grade
* `2nd Grade` - 2nd Grade
* `1st Grade` - 1st Grade
 */
export type GradeEnum = typeof GradeEnum[keyof typeof GradeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GradeEnum = {
  College_Senior: 'College Senior',
  College_Junior: 'College Junior',
  College_Sophomore: 'College Sophomore',
  College_Freshman: 'College Freshman',
  High_School_Senior: 'High School Senior',
  High_School_Junior: 'High School Junior',
  High_School_Sophomore: 'High School Sophomore',
  High_School_Freshman: 'High School Freshman',
  '8th_Grade': '8th Grade',
  '7th_Grade': '7th Grade',
  '6th_Grade': '6th Grade',
  '5th_Grade': '5th Grade',
  '4th_Grade': '4th Grade',
  '3rd_Grade': '3rd Grade',
  '2nd_Grade': '2nd Grade',
  '1st_Grade': '1st Grade',
} as const;
